module.exports = new __parcel__URL__("Charlie_Text-Regular.5c16e95e.woff").toString();